<button
  [type]="buttonType"
  [disabled]="disabled"
  class="button {{ buttonClass }} back-btn"
>
  <img src="assets/icons/ic-arrow-left@3x.svg" alt="" />
</button>
